export default __webpack_public_path__ + "img/alarms.6cc24f1f.png";